import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";

const Loader = () => {
  const loading = useSelector(state => state.loader.loading);
  if (!loading){
    return;
  }

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={3}
      style={{ position: "fixed", height: "100vh", width: "100vw", backgroundColor: "rgba(0,0,0,.4)", overflowX: "hidden", zIndex: "99999", top: 0 }}
    >
      <CircularProgress size={150} />
      <Typography variant={"h4"} color={"white"}>Cargando...</Typography>
    </Stack>
  );
};

export default Loader;
